export class MClassification {
    id: string

    name: string

    code: string

    value: string

    constructor(classification: MClassification) {
        this.id = classification?.id
        this.name = classification?.name
        this.value = classification?.code
        this.code = classification?.code
    }
}
